import {Cell} from "react-table";
import {FormattedMessage} from "react-intl";

/**
 * Rendert die "Status"-Tabellen-Zelle für das Einreichungslisting
 *
 * @param cell
 * @constructor
 */
const StatusColumn: (cell: Cell) => JSX.Element = (cell: Cell) => {

    /**
     * Gibt den i18n-String anhand des Entscheidungsstrings aus der API zurück
     *
     * @param decision
     */
    const getDecisionMessage: (decision: string) => JSX.Element = (decision: string) => {
        switch (decision) {
            case 'SUBMISSION_ACCEPTED':
                return (
                    <span>
                        <i className='fa fa-check'/>
                        <FormattedMessage id="myarea.listing.column.body.status.decision.accepted"/>
                    </span>
                );
            case 'SUBMISSION_DECLINED':
                return (
                    <span>
                        <i className='fa fa-times'/>
                        <FormattedMessage id="myarea.listing.column.body.status.decision.declined"/>
                    </span>
                );
            case 'SUBMISSION_POTENTIALLY_ACCEPTED':
                return (
                    <span>
                        <i className='fa fa-question-circle-o'/>
                        <FormattedMessage id="myarea.listing.column.body.status.decision.potentialyAccepted"/>
                    </span>
                );
            default:
                return (
                    <span>
                        <i className='fa fa-circle-o'/>
                        <FormattedMessage id="myarea.listing.column.body.status.decision.none"/>
                    </span>
                );
        }
    }

    /**
     * Gibt den i18n-String anhand der Vollständigkeit der Einreichung zurück
     *
     * @param isCompleteSubmission
     */
    const getStatusMessage: (isCompleteSubmission: boolean) => JSX.Element = (isCompleteSubmission: boolean) => {
        if (isCompleteSubmission) {
            return (
                <span>
                    <i className='fa fa-check'/>
                    <FormattedMessage id="myarea.listing.column.body.status.complete"/>
                </span>
            );
        }

        return (
            <span>
                <i className='fa fa-times'/>
                <FormattedMessage id="myarea.listing.column.body.status.incomplete"/>
            </span>
        );
    }

    return (
        <span>
            <p>{getStatusMessage(cell.row.values.status.isCompleteSubmission)}</p>
            <p>{getDecisionMessage(cell.row.values.status.decision)}</p>
        </span>
    );
}

export default StatusColumn;